import store from '../../init/store.js'
import {setBattleValue} from '../../redux-actions/battle-actions.js'
import {recordTurnActivityInRoom} from '../connection/firebase-rooms.js'

function getCombatantReportDataPerTurn(combatantModel, descriptionObject) {

  let updatedStatePerCombatant =  descriptionObject.state[combatantModel.id] || {};

  return {
    id: combatantModel.id,
    hp: combatantModel.hp,
    maxHp: combatantModel.hp,
    pp: combatantModel.pp,
    maxPp: combatantModel.pp,
    status: combatantModel.pp,
    control: combatantModel.isBot ? "bot" : "player",
    class: combatantModel.class,
    level: combatantModel.level,
    teamId: combatantModel.belongsToTeam,
    ...updatedStatePerCombatant
  }
}

export function createTurnReport(rollout, descriptionObject, actionModel, casterModel, targetModels) {
  //console.log(casterModel, targetModels)

  const casterData = getCombatantReportDataPerTurn(casterModel, descriptionObject);
  let targetsData = {};
  targetModels.forEach(targetModel => {
    targetsData[targetModel.id] = getCombatantReportDataPerTurn(targetModel, descriptionObject)
  });


  if (!actionModel.id) {
    console.warn('no action id found when creating Turn Report', actionModel)
  }

  return {
    actionId: actionModel.id,
    actionName: actionModel.name,
    casterData,
    targetsData,
    descriptionData: descriptionObject.description
  }
}




export function addReportToReportingHistory(turnReport) {
  const turnKey = "t" + store.getState().battle.rolloutHistory.length;
  setBattleValue({
    turnReporting: {
      ...store.getState().battle.turnReporting,
      [turnKey]: turnReport
    }
  });


  /* IF ONLINE PLAY, Write this turnKey to firebase state */
  if (store.getState().battle.isMultiplayerMode) {
    recordTurnActivityInRoom(turnKey, turnReport);
  }
  ////////////////////////////////////////////////////////////////


}

// window.getTurnReports = function() {
//   console.log(
//     JSON.stringify(store.getState().battle.turnReporting)
//   );
//   return store.getState().battle.turnReporting;
// };


// WEBPACK FOOTER //
// ./src/battle/analysis/turn-reporting.js